import { storage } from '@abyss/web/tools/storage';
import { useShallow } from 'zustand/react/shallow';

import { Constants } from '../../common/Constants';
import { useGuestStore } from '../../store/useGuestStore';
import { GuestState } from '../../store/useGuestStore/guestStore';
import { getMemberDataFromGuestData } from '../../utils/guest.utils';
import { StoreKeys } from '../useStore/state';
import { useStore } from '../useStore/useStore';

export const useCurrentMember = () => {
  const { guestData } = useGuestStore(
    useShallow((state: GuestState) => ({
      guestData: state.guestData,
    }))
  );

  const isGuest = storage.session.get(Constants.STORAGE_KEYS.SESSION.IS_GUEST);

  const memberInfo = useStore(StoreKeys.OBAPI_MEMBERS);

  if (guestData?.ndbLob) {
    return getMemberDataFromGuestData(guestData);
  }

  const guestUser = isGuest
    ? storage.session.get(Constants.STORAGE_KEYS.SESSION.GUEST_USER)
    : {};
  if (isGuest) {
    return guestUser;
  }

  const currentIndex =
    storage.session.get(Constants.STORAGE_KEYS.SESSION.ACTIVE_MEMBER_INDEX) ||
    0;

  return memberInfo?.[currentIndex] ?? memberInfo?.[0];
};

export const useDependentInfo = (dependentSeqNbr = '') => {
  const currentMember = useCurrentMember();
  const memberInfo = useStore(StoreKeys.OBAPI_MEMBERS);

  if (currentMember?.isIFPEarlyPay) {
    return currentMember; // for IFP early pay, return the logged in member as dependent info
  }

  if (!dependentSeqNbr) return undefined;

  return memberInfo?.find(
    (member) => member?.demographics.dependentSeqNbr === dependentSeqNbr
  );
};

export const useCurrentMemberOrDependentInfo = (dependentSeqNbr = '') => {
  const currentMember = useCurrentMember();

  const memberInfo = useStore(StoreKeys.OBAPI_MEMBERS);

  if (currentMember?.isIFPEarlyPay) {
    return currentMember; // for IFP early pay, return the logged in member as dependent info
  }

  if (dependentSeqNbr) {
    return memberInfo?.find(
      (member) => member?.demographics.dependentSeqNbr === dependentSeqNbr
    );
  }

  return currentMember;
};
